class ExcecaoConfirmadaController extends AbstractController
  @$inject = ['$injector', '$scope', 'gql', 'pathService', 'excecaoConfirmadaService', '$uibModal']

  constructor: ($injector, @scope, @gql, pathService, @excecaoConfirmadaService, @$uibModal) ->
    super($injector)

    @loadingTracker = @promiseTracker()
    @submitTracker = @promiseTracker()
    url = "#{pathService.getViewUrl()}eficiencia-fiscal/view/configuracao/icms/excecao-confirmada/"
    @modalExcecaoConfirmada = @openPopup(url + "modal.html", 'excecaoConfirmadaModalController as ctrl')
    @modalParecerTecnico = @openPopup(pathService.getViewUrl() + 'eficiencia-fiscal/view/configuracao/icms/parecer-tecnico/modal.html', 'parecerTecnicoController as ctrl', 'lg', 'static')

    @listOfExcecaoConfirmada = []

    @filtro =
      descricao: ''
      pendente: true

    @pagination =
      page: 1
      perPage: 1
      totalPages: 0

    @loadData()

  loadData: (page = 1) ->
    filtro = angular.copy @filtro
    filtro.page = page

    if filtro.periodo
      filtro.dataInicial = filtro.periodo.inicial if filtro.periodo.inicial
      filtro.dataFinal = filtro.periodo.final if filtro.periodo.final

    delete filtro.periodo

    @loadingTracker.addPromise @excecaoConfirmadaService.getList(filtro, (result) =>
      if result.success
        @listOfExcecaoConfirmada = result.data.items.map((excecaoConfirmada) =>
          excecaoConfirmada.participantes = excecaoConfirmada.nfes
            .flatMap((nfe) => 
              filial = angular.copy(nfe.filial)
              filial.isFilial = true
              
              [filial, nfe.emitente]
            )
            .uniqBy((p) => p.cnpj)

          excecaoConfirmada
        )

        @pagination =
          page: filtro.page
          totalPages: result.data.totalPages
          perPage: 1
      else
        @Alert.error('Ocorreu um erro ao buscar lista de exceções.', 'Erro!', false)
    )

  detalhes: (excecaoConfirmada) ->
    @modalExcecaoConfirmada({excecaoConfirmada: -> excecaoConfirmada}, (result) =>
      if result.ok
        excecaoConfirmada = result.data

        index = @listOfExcecaoConfirmada.getIndex(excecaoConfirmada.id, 'id')
        @listOfExcecaoConfirmada[index] = excecaoConfirmada
    )

  send: (confirmado, excecaoConfirmada, $event) ->
    mutationVariables = { ncm: excecaoConfirmada.ncm, codigoBarras: excecaoConfirmada.codigoBarras }

    options =
      clickEvent: $event,
      loadingText: '',

    @submitTracker.addPromise @excecaoConfirmadaService.save({id: excecaoConfirmada.id, confirmado: confirmado}, (data) =>
      if data.success
        excecaoConfirmada = data.data

        confirmado =
          if confirmado == excecaoConfirmada.confirmado
            switch excecaoConfirmada.confirmado
              when true then 'confirmada'
              when false then 'negada'
          else
            'atualizada'

        index = @listOfExcecaoConfirmada.getIndex(excecaoConfirmada.id, 'id')
        @listOfExcecaoConfirmada[index] = excecaoConfirmada

        if confirmado
          @gql.mutate(gql(["mutation ($ncm: String!, $codigoBarras: String) {
            deleteAuditoriasContinuas(ncm: $ncm, codigoBarras: $codigoBarras)
          }"]), mutationVariables)

        Alert.success("Condição proposta Nº <strong>#{excecaoConfirmada.id}</strong> <u>#{ confirmado }</u> com sucesso.", 'Sucesso!')

    , options)

  confirmar: (excecaoConfirmada, $event) ->
    @send(true, excecaoConfirmada, $event)

  negar: (excecaoConfirmada, $event) ->
    @send(false, excecaoConfirmada, $event)

  markAsPendente: (excecaoConfirmada, $event) ->
    @send(null, excecaoConfirmada, $event)

  getCondicoes: (excecaoConfirmada) ->
    atual: excecaoConfirmada.excecao.itemTabela
    proposta: excecaoConfirmada.excecao

  getColegiados: (excecaoConfirmada) ->
    confirmadas: excecaoConfirmada.colegiadoConfirmados
    negados: excecaoConfirmada.colegiadoNegados

  totalColegiados: (excecaoConfirmada) ->
    excecaoConfirmada.colegiadoConfirmados.length + excecaoConfirmada.colegiadoNegados.length

  openParecerTecnicoModal: (excecao) ->
    @modalParecerTecnico({
      excecao: -> excecao.id
    })

  showTributacoesItens: (codigoBarras) ->
    @$uibModal.open({
      component: 'tributacoesItensModal',
      size: 'md',
      resolve: {
        codigoBarras: () => codigoBarras,
      }
    })

class ExcecaoConfirmadaModalController extends AbstractController
  @$inject = ['$injector', 'pathService', 'excecaoConfirmadaService', '$uibModalInstance', 'excecaoConfirmada', 'gql', 'downloadService', '$scope' ]

  constructor: ($injector, pathService, @excecaoConfirmadaService, @modalInstance, excecaoConfirmada, @gql, @downloadService, @scope) ->
    super($injector)

    @submitTracker = @promiseTracker()
    @modalParecerTecnico = @openPopup(pathService.getViewUrl() + 'eficiencia-fiscal/view/configuracao/icms/parecer-tecnico/modal.html', 'parecerTecnicoController as ctrl', 'lg', 'static')

    @excecaoConfirmada = angular.copy excecaoConfirmada

    @confirmado = @excecaoConfirmada.confirmado
    @condicoes =
      atual: @excecaoConfirmada.excecao.itemTabela
      proposta: @excecaoConfirmada.excecao

  send: (confirmado, $event) ->
    @excecaoConfirmada.confirmado = confirmado

    options =
      clickEvent: $event,
      loadingText: if confirmado then 'Confirmando...' else 'Negando...',

    @submitTracker.addPromise @excecaoConfirmadaService.save(@excecaoConfirmada, (data) =>
      Alert.success("Condição proposta Nº <strong>#{@excecaoConfirmada.id}</strong> <u>#{if @excecaoConfirmada.confirmado then 'confirmada' else 'negada'}</u> com sucesso.", 'Sucesso!')
      @modalInstance.close(new Retorno(true, null, data))
    , options)

  delete: (status) ->
    Confirm.warning('Atenção', 'Deseja realmente excluir esta confirmação de exceção e relatar o NCM desde produto como inconsistente?', {
      'Sim': =>
        @excecaoConfirmadaService.delete({id: @excecaoConfirmada.id, status: status}, (data) =>
          if data.success
            Alert.success("O NCM inconsistente para a condição proposta Nº <strong>#{@excecaoConfirmada.id}</strong> foi cadastrado com sucesso!", 'Sucesso!')
            @modalInstance.close(new Retorno(true, null, data))
          else
            @Alert.error("Ocorreu um erro inesperado ao tentar relatar a NCM como inconsistente.", "Erro")
        )
      'Não': => null
    })

  downloadOperation: (tokenPromise) ->
    tokenPromise
      .then((token) => @downloadService.download("/resume-operation/#{token}"))
      .catch(console.error)

  fetchTokenNfe: (nfe, format) ->
    query =
      gql(["""
          query DownloadNfeDa($filialId: Int!, $filter: NfeFilter!) {
              filial(id: $filialId) {
                  id
                  nfesPage(filter: $filter) {
                      nfes: entries {
                          ... on Nfe {
                              #{format} { token }
                          }
                      }
                  }
              }
          }
      """])

    @gql
      .query(query, { filialId: nfe.filialId, filter: { chave: nfe.key } })
      .then((response) => 
        response.filial.nfesPage.nfes[0][format].token
      )

  downloadDanfe: (nfe) ->
    @downloadOperation(@fetchTokenNfe( nfe, 'danfe'))

  confirmar: ($event) ->
    @send(true, $event)

  negar: ($event) ->
    @send(false, $event)

  relatar: ->
    @delete('ncm_inconsistente')

  openParecerTecnicoModal: (excecao) ->
    @modalParecerTecnico({
      excecao: -> excecao.id
    })

  downloadExtratoIcms: (nfeId) ->
    url = "/api/eficiencia-fiscal/extrato-nfe-icms?nfe=#{nfeId}&reauditar=false&q=emitir"
    cbk.download(url)
  
angular.module('eficienciaFiscalModule').controller('excecaoConfirmadaController', ExcecaoConfirmadaController)
angular.module('eficienciaFiscalModule').controller('excecaoConfirmadaModalController', ExcecaoConfirmadaModalController)
